import { render, staticRenderFns } from "./SupervisorsList.vue?vue&type=template&id=d91f7060&scoped=true&"
import script from "./SupervisorsList.vue?vue&type=script&lang=js&"
export * from "./SupervisorsList.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorsList.vue?vue&type=style&index=0&id=d91f7060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91f7060",
  null
  
)

export default component.exports